module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0739-min.022dd0b1.jpg";